"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _skeletonPreloader = require("@influitive/secret-garden/lib/skeleton-preloader");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SkeletonPreloader =
/*#__PURE__*/
(0, _styled.default)('div', {
  target: "e9yu2q60"
})(_skeletonPreloader.pulsatingAnimation);
var Avatar =
/*#__PURE__*/
(0, _styled.default)(_skeletonPreloader.PreloaderElement, {
  target: "e9yu2q61"
})("border-radius:100%;height:60px;overflow:hidden;width:60px;");
var Attributes =
/*#__PURE__*/
(0, _styled.default)(_skeletonPreloader.PreloaderElement, {
  target: "e9yu2q62"
})("height:60px;margin-left:", (0, _styledSystem.themeGet)('spacing.4'), "px;width:194px;");
var DetailsContainer =
/*#__PURE__*/
(0, _styled.default)('div', {
  target: "e9yu2q63"
})("display:flex;");
var Action =
/*#__PURE__*/
(0, _styled.default)(_skeletonPreloader.PreloaderElement, {
  target: "e9yu2q64"
})("float:right;height:36px;margin:", (0, _styledSystem.themeGet)('spacing.2'), "px 0 0 ", (0, _styledSystem.themeGet)('spacing.1'), "px;width:60px;");

var Loading =
/*#__PURE__*/
function (_Component) {
  _inherits(Loading, _Component);

  function Loading() {
    _classCallCheck(this, Loading);

    return _possibleConstructorReturn(this, _getPrototypeOf(Loading).apply(this, arguments));
  }

  _createClass(Loading, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(SkeletonPreloader, null, _react.default.createElement(DetailsContainer, null, _react.default.createElement(Avatar, {
        className: "c-avatar"
      }), _react.default.createElement(Attributes, {
        className: "c-attributes"
      })), _react.default.createElement(Action, null), _react.default.createElement(Action, null));
    }
  }]);

  return Loading;
}(_react.Component);

exports.default = Loading;